export const CLEAR_ORGANISATION_STATISTICS = '[ Organisation ] Clear statistics'
export const FETCH_ORGANISATION = '[ Organisation ] Fetch organisation'
export const FETCH_ORGANISATIONS = '[ Organisation ] Fetch organisations view model'
export const FETCH_ORGANISATION_STATISTICS = '[ Organisation ] Fetch statistics'
export const SEARCH_ORGANISATIONS = '[ Organisation ] Search organisations'

export const UPDATE_ORGANISATION = '[ Organisation ] Update organisation'

export const CREATE_ORGANISATION_POST = '[ Organisation ] Create a new post'
export const DELETE_ORGANISATION_POST = '[ Organisation ] Delete a post'
export const FETCH_ORGANISATION_POSTS = '[ Organisation ] Load posts'
export const UPDATE_ORGANISATION_POST = '[ Organisation ] Update post'

export const FETCH_ORGANISATION_ACTIVITIES = '[ Organisation ] Fetch activities'

export const FETCH_ORGANISATION_INTERACTIONS = '[ Organisation ] Fetch interactions'
